import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IDSConfigState = { };

const designTypeReducer = (
  state: types.IDSConfigState = defaultState, 
  action: IAction | types.ISetDSConfigAction | types.IAddBrand | types.IRemoveBrand
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_DSCONFIG: {
      return {...state, dsconfig: (action as types.ISetDSConfigAction).dsconfig};
    }
    case actionTypes.ADD_BRAND: {
      const brandDefinition = (action as types.IAddBrand).brandDefinition
      const dsConfig = state.dsconfig;
      if (dsConfig) dsConfig.brands = [...dsConfig.brands, brandDefinition]
      return {...state, dsConfig}
    }
    case actionTypes.REMOVE_BRAND: {
      const brandId = (action as types.IRemoveBrand).id
      const dsConfig = state.dsconfig;
      if (dsConfig) dsConfig.brands = dsConfig.brands.filter(b => b.id !== brandId)
      return {...state, dsConfig}
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
